module.exports = __webpack_public_path__ + "static/media/51.8ac3a963.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/accessoires/51.png
// module id = 476
// module chunks = 0